export const GET_NEWS_URL = '/news-articles/get-all-by-stock';
export const GET_TRADING_VOLUME_CHART_URL =
  '/share/get-trading-volume-close-price-by-code';
export const GET_FINANCIAL_CHART_URL = '/financial/get-all-by-stock-and-type';
export const GET_CHART_DATA_BY_CODE_URL = '/share/get-chart-data-by-code';
export const GET_HISTORIES_TRADE_BY_CODE_URL =
  '/share/get-lich-su-giao-dich-theo-machungkhoan';
export const GET_RELATED_COMPANY_URL = '/share/get-related-company';
export const GET_RELATED_COMPANY_CHART_URL =
  '/share/get-chart-data-for-related-company';
export const APP_INFO_URL = '/share/app-info';
export const GET_INVESTMENTS_URL =
  '/investment/get-investment-by-user-for-table';
export const GET_TOTAL_SENT_NOTIFICATION_URL =
  '/notification/get-total-sent-notification';
export const GET_TOTAL_UNREAD_OR_SENT_NOTIFICATIONS_URL =
  '/notification/get-unread-or-sent-notifications';
export const UPDATE_VIEW_STATUS_FOR_NOTIFICATION_URL =
  '/notification/update-view-status-for-notifications';
export const UPDATE_VIEW_STATUS_FOR_NOTIFICATION_BY_IDS_URL =
  '/notification/update-view-status-for-notifications-by-ids';
export const MASK_AS_READ_NOTIFICATION_URL = '/notification/mask-as-read';
export const GET_ALL_FOLLOW_COMPANY_URL =
  '/follow-company/get-all-follow-company';
export const GET_BY_CODE_FOLLOW_COMPANY_URL = '/follow-company/get-by-code';
export const DELETE_ALL_FOLLOW_COMPANY_URL = '/follow-company/delete-all';
export const SAVE_FOLLOW_COMPANY_URL = '/follow-company/save';
export const GET_INVESTMENT_STOCKS_FOR_NOTIFICATION_URL =
  '/investment/get-stocks-for-notification';
export const GET_INVESTMENT_CATEGORY_URL =
  '/investment-category/get-all-category';
export const GET_TOTAL_UNREAD_NOTIFICATION_URL =
  '/notification/get-unread-notification';
export const GET_INVESTMENT_NOTIFICATION_URL =
  '/notification/get-investment-notification';
export const GET_FOLLOW_COMPANY_NOTIFICATION_URL =
  '/notification/get-follow-company-notification';
export const GET_SYSTEM_NOTIFICATION_URL =
  '/notification/get-system-notification';
export const GET_DETAIL_COMPANY = '/company/get-detail-company';
export const GET_SOURCE_OF_NEWS = '/news-articles/get-all-source';
export const GET_NEWS_BY_SOURCE_URL = '/news-articles/get-news-by-source';
export const ADMIN_GET_NEWS = '/news-articles/get-news-items';
export const ADMIN_GET_TOTAL_NEWS = '/news-articles/get-total-items';
export const ADMIN_GET_LATEST_PUBLISH_DATE_NEWS =
  '/news-articles/get-latest-publish-date';
export const ADMIN_UPDATE_STATUS_NEWS = '/news-articles/status';
export const ADMIN_DELETE_NEWS = '/news-articles/delete';
export const ADMIN_GET_SOURCES = '/news-articles/get-sources';
export const IDENTIFY_SAVE_URL = '/identify/save';
export const IDENTIFY_ALL_URL = '/identify/all';
export const USER_ME = '/user/me';
export const NEWS_ANALYSIS_POINTS_URL = '/news-analysis/points';
export const ADMIN_UPDATE_STOCK_NEWS = '/news-articles/update-stock';
export const GET_HISTORIES_BY_USER = '/login-history/get-histories-by-user';
export const UPDATE_USER_INFO = '/user/update-user-info';
export const UPDATE_NEW_PASSWORD = '/user/update-new-password';
export const UPDATE_ALL_EXPIRED_DATE = '/package-order/update-all-expired-date';
export const SAVE_NOTIFICATION_OPTIONS = '/user/save-notification-options';
export const PACKAGE_ORDER_HISTORY = '/package-order/history';
export const GET_USER_BY_ID = '/user/user-by-id';
export const GET_ALL_PACKAGE = '/package/all';
export const GET_CURRENT_PACKAGE = '/package-order/current-package';
export const UPDATE_VIEW_STATUS_NOTIFICATION_BY_ID =
  '/notification/update-view-status-by-id';
export const GET_AI_ANALYSIS_BY_STOCK = '/ai-analysis/get-data-by-stock';
export const GET_AI_ANALYSIS_INVESTMENT_BY_USET =
  '/ai-analysis-investment/get-data-by-user';
export const GET_ALL_SOURCE_OF_NEWS = '/news-articles/get-all-source-for-news';
export const GET_ALL_NEWS_BY_SOURCE_URL =
  '/news-articles/get-all-news-by-source';
export const GET_HIGHLIGHT_DATA_URL =
  '/super-search/get-data-for-highlight-page';
export const GET_CATEGORY_DATA_URL = '/category/danh-muc-nganh';
export const ADMIN_UPDATE_HOLIDAY_SETTING = '/app-settings/update-holiday';
export const ADMIN_GET_HOLIDAY_SETTING = '/app-settings/get-holidays';
export const GET_NOTIFICATION_MODAL = '/action-log/notification';
export const CREATE_NOTIFICATION_LOG_MODAL = '/action-log/create-notification';
export const GET_HIGHLIGHT_CHART_DATA_URL =
  '/super-search/get-chart-data-for-highlight-page';
export const GET_TOP_10_GO_UP_BY_STOCKUP =
  '/super-search/get-top-10-go-up-by-stockup';
export const GET_TOP_10_GO_DOWN_BY_STOCKUP =
  '/super-search/get-top-10-go-down-by-stockup';
export const GET_COMPANIES = '/company/ma-chung-khoan';
export const GET_ANALYSIS_DATA = '/super-search/analysis';
export const GET_LATEST_MARKET_NEWS_DATA = '/market-news/get-latest-data';
export const GET_TOP_60_SECTOR_UP_TRENDING_DATA =
  '/sector-trending/get-up-trending-data';
export const ADMIN_GET_NOTIFICATION_LOG = '/notify/notification-logs';
export const ADMIN_UPDATE_NOTIFICATION_LOG_STATUS = '/notify/update-status';
export const ADMIN_CREATE_NOTIFICATION_LOG = '/notify/create-data';
export const CREATE_PROPICK_FOLLOW = '/follow-company/create-propick-follow';
export const GET_ALL_STOCK_PROPICK = '/stock-propick/all';
export const GET_ALL_INVESTMENT_STOCK = '/investment/get-investment-stocks';
export const GET_APP_INFO = '/share/app-info';
export const SAVE_INVESTMENT_CATEGORY = '/investment-category/save';
export const GET_FUTURES_INSIGHT_TICKER = '/futures-insight-ticker/all';
export const GET_DAILY_BUY_AND_SELL_LIVE_DATA =
  '/share/get-daily-buy-and-sell-live';
export const GET_DAILY_BUY_AND_SELL_LIVE_15_MINUTES_DATA =
  '/share/get-daily-buy-and-sell-live-15-minutes';
export const GET_DAILY_TRADING_HISTORY_LIVE_DATA =
  '/share/get-daily-trading-history-live';
export const GET_DAILY_TRADING_HISTORY_LIVE_15_MINUTES_DATA =
  '/share/get-daily-trading-history-live-15-minutes';
export const GET_DAILY_TRADING_HISTORY_CHART_DATA =
  '/share/get-daily-trading-history-for-chart';
export const GET_SALES_CONTRACT_QUANTITY_CHART_DATA =
  '/share/get-sales-contract-quantity-chart';
export const GET_FUTURES_CONTRACT_INFO = '/share/get-futures-contract-info';
export const GET_LARGE_DAILY_TRADING_HISTORY_LIVE_DATA =
  '/share/get-large_daily-trading-history-live';
export const GET_DAILY_TRADING_LIMIT_DATA = '/share/get-daily-trading-limit';
export const GET_DAILY_TRADING_HISTORY_NEXT_ACTION_DATA =
  '/share/get-daily-trading-history-next-action';
export const GET_FUTURE_PACKAGE_LIST = '/package/get-future-package-list';
export const PACKAGE_ORDER_CONFIRM = '/package-order/futures-order-confirm';
export const MANAGEMENT_PACKAGE_ORDER_CONFIRM = 'package-order/confirm';
export const REMOVE_STOCK_PROPICK = '/stock-propick/remove';
export const ADD_STOCK_PROPICK = '/stock-propick/add';
export const GET_ALL_STOCK_TRENDING = '/stock-trending/all';
export const REMOVE_STOCK_TRENDING = '/stock-trending/remove';
export const ADD_STOCK_TRENDING = '/stock-trending/add';
export const GET_ALL_STOCK_TRADING = '/stock-trading/all';
export const REMOVE_STOCK_TRADING = '/stock-trading/remove';
export const ADD_STOCK_TRADING = '/stock-trading/add';
export const UPDATE_PRICE_INFO = '/share/update-price';
export const ACTIVE_FREE_FEATURE_PACKAGE =
  '/package-order/active-free-feature-package';
export const SAVE_USER_OPTIONS = '/user/save-options';
export const ADMIN_GET_USERS = '/user/paginate';
export const ADMIN_GET_FEEDBACK = '/help-desk/feedback';
export const ADMIN_GET_REPORT_DATA = '/help-desk/report-data';
export const ADMIN_GET_SUPPORT_DATA = '/help-desk/support';
export const ADMIN_SEND_EMAIL_FOR_USER = '/user/send-email';
export const ADMIN_GET_ALL_USER_EMAIL = '/user/all-user-email';
export const ADMIN_GET_EMAIL_LIST = '/app-settings/email-list';
export const ADMIN_GET_SCHEDULE_EMAIL_LIST = '/share/schedule-list';
export const ADMIN_DELETE_SCHEDULE_EMAIL = '/share/delete-schedule';
export const SAVE_FOLLOW_COMPANY_NOTE = '/share/save-follow-company-note';
export const GET_FOLLOW_COMPANY_NOTE = '/share/get-follow-company-note';
export const SAVE_AI_AGENT_USER_CONTENT = '/share/save-ai-agent-user-content';
export const GET_AI_AGENT_QUESTIONS = '/share/get-ai-agent-questions';
export const SAVE_AI_AGENT_QUESTIONS = '/share/save-ai-agent-question';
export const DELETE_AI_AGENT_QUESTIONS = '/share/delete-ai-agent-questions';
export const UPDATE_STATUS_AI_AGENT_QUESTIONS =
  '/share/update-status-ai-agent-questions';
export const GET_USER_QUESTIONS = '/share/get-user-questions';
export const GET_USER_CONTENT = '/share/get-user-content';
export const GET_AI_SETTINGS = '/share/get-ai-settings';
export const SAVE_AI_SETTINGS = '/share/save-ai-settings';
export const GET_AUTOCOMPLETE = '/share/get-autocomplete';
export const GET_ANSWER_QUESTION_ID = '/share/get-answer-by-question-id';
export const SAVE_ANSWER = '/share/save-answer';
export const UPDATE_STATUS_ANSWER = '/share/update-status-answer';
export const DELETE_ANSWER = '/share/delete-answer';
export const SAVE_STATIC_DATA = '/share/save-static-data';
export const GET_STATIC_DATA = '/share/get-static-data';
export const GET_AI_PACKAGE_LIST = '/package/get-ai-package-list';
export const AI_PACKAGE_ORDER_CONFIRM = '/package-order/ai-order-confirm';
export const AI_UPLOAD_PAYMENT = '/upload/upload-payment';
export const GET_TOTAL_TOKEN = '/package-order/get-total-token';
export const CHECK_USER_MODAL = '/user/check-user-modal';
export const GET_LATEST_NEWS = '/news-articles/get-latest-article';
export const GET_PROPICK_QUESTION = '/share/get-propick-question';
export const SAVE_AI_AGENT_PROPICK = '/share/save-ai-agent-propick';
